import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate scroll to top for better performance
    window.scrollTo(0, 0);
    
    // Smooth scroll after a brief delay for better UX
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);
  }, [pathname]);

  useEffect(() => {
    // Handle page refresh and initial load
    window.scrollTo(0, 0);
    
    // Disable browser's automatic scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    
    // Preload critical resources for better performance
    const preloadCriticalResources = () => {
      const criticalRoutes = ['/about', '/courses', '/contact', '/blog', '/faq'];
      criticalRoutes.forEach(route => {
        if (pathname === route) {
          // Preload next likely routes
          const nextRoutes = criticalRoutes.filter(r => r !== route);
          nextRoutes.forEach(nextRoute => {
            const link = document.createElement('link');
            link.rel = 'prefetch';
            link.href = nextRoute;
            document.head.appendChild(link);
          });
        }
      });
    };
    
    preloadCriticalResources();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
